import * as selectors from './settings.selectors';
import reducer from './settings.reducers';

export default reducer;
export { selectors, reducer };
export { SettingsAction } from './settings.actions';
export { SettingsEffects } from './settings.effects';
export { SettingsState } from './settings.models';
export { SettingsService } from './settings.service';
